<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--基本信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000929') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item" v-for="(item, index) in basicInfoList" :key="index">
            <span class="basic_title">{{ item.name }}</span>
            <span class="basic_txt">{{ detailsData[item.paramsKey] }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--充值记录-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002931') }}</h2>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="400"
            :loading="tableLoading"
            :columns="rechargeRecordColumns"
            :data="rechargeRecordData">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="rechargeRecordTotal"
            @on-change="(val)=>changeTypePage(val, 'rechargeRecordPageParams')"
            show-total
            :page-size="rechargeRecordPageParams.pageSize"
            show-elevator
            :current="rechargeRecordPageParams.pageNum"
            show-sizer
            @on-page-size-change="(val)=> changeTypePageSize(val, 'rechargeRecordPageParams')"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </Card>
    </div>
    <!--消费记录（订单仅计算已取消及已出库部分）-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1003955') }}</h2>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="400"
            :loading="tableLoading"
            :columns="consumptionRecordsColumns"
            :data="consumptionRecordsData">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="consumptionRecordsTotal"
            @on-change="(val)=>changeTypePage(val, 'consumptionRecordsPageParams')"
            show-total
            :page-size="consumptionRecordsPageParams.pageSize"
            show-elevator
            :current="consumptionRecordsPageParams.pageNum"
            show-sizer
            @on-page-size-change="(val)=> changeTypePageSize(val, 'consumptionRecordsPageParams')"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {getUserNameByUserId, isValueEmpty, downloadTemplateFile, setConfigCharacters, isImageFile, getAllUsersInfo, getDataSetBatchList, getEnumName} from "@/utils/common";

export default {
  name: "customerBillDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      ItemCol: 6,
      detailsData: {},
      basicInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003685'), paramsKey: 'billNo'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003649'), paramsKey: 'businessMerchantId'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003593'), paramsKey: 'billTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003594'), paramsKey: 'createdTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003944'), paramsKey: 'accumulatedRecharge'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003945'), paramsKey: 'platformRechargePrice'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003946'), paramsKey: 'handRechargePrice'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003947'), paramsKey: 'consumptionAmount'}
      ],
      rechargeRecordPageParams: {
        pageNum: 1,
        pageSize: 15
      },
      rechargeRecordTotal: 0,
      rechargeRecordColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003623'),
          key: 'ymsDistributorMerchantRechargeRecordId',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003624'),
          key: 'paymentSerialNumber',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003948'),
          key: 'paymentPicturePath',
          minWidth: 260,
          align: 'center',
          render(h, params) {
            let imgList = [];
            let fileList = [];
            let paymentPicturePathList = params.row.ymsDistributorMerchantRechargeRecordImages || [];
            if (paymentPicturePathList.length > 0) {
              paymentPicturePathList.map((item) => {
                if (isImageFile(item.paymentPicturePath)) {
                  imgList.push(h('div', {class: 'm5'}, [v.tableImg(h, params, null, item.paymentPicturePath)]));
                } else {
                  fileList.push(h('p', {
                    class: 'cursor mt2 mb2 themeColor',
                    style: {
                      textAlign: 'left'
                    },
                    on: {
                      click() {
                        if (item.paymentPicturePath) {
                          downloadTemplateFile(item.paymentPicturePath);
                        }
                      }
                    },
                  }, item.name));
                }
              });
              return h('div', [
                h('div', {class: 'flex flex-wrap'}, [imgList]),
                fileList
              ]);
            }
          },
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003625'),
          key: 'rechargeAmount',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.rechargeAmount);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003626'),
          key: 'paymentMethod',
          minWidth: 120,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003627'),
          key: 'createdTime',
          minWidth: 170,
          align: 'center',
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'createdBy',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: '',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remarks, 200, 2);
          }
        }
      ],
      rechargeRecordData: [],
      consumptionRecordsPageParams: {
        pageNum: 1,
        pageSize: 15
      },
      consumptionRecordsTotal: 0,
      consumptionRecordsColumns: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`,
          key: 'packageCode',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917'),
          key: 'status',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let text = getEnumName(this.enumData, 'YmsPackageInfoStatusCoreEnum', status);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003629'),
          key: 'orderShippingId',
          minWidth: 150,
          align: 'center'
        },
        {
          title: `${setConfigCharacters(false)}SKU`,
          key: 'ymsSku',
          minWidth: 170,
          align: 'center',
          render(h, params) {
            let ymsSkus = params.row.ymsSkus || [];
            if (ymsSkus.length > 0) {
              return h('div', ymsSkus.map(i => h('p', {class: 'mt3 mb3'}, i)));
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003630'),
          key: 'productQuantity',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let text = params.row.productQuantity || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003631'),
          key: 'totalWeight',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let text = params.row.totalWeight || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003632'),
          key: 'totalProductGoodsCost',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let text = params.row.totalProductGoodsCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003949'),
          key: 'withholdingLogisticsFees',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let text = params.row.logisticsCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003950'),
          key: 'actualDeductionOfLogisticsFees',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let text = params.row.actualLogisticsCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003635'),
          key: 'prepayPackageHandlerCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = params.row.prepayPackageHandlerCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003636'),
          key: 'packageHandlerCost',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = params.row.packageHandlerCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003642'),
          key: 'domesticExpressFee',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let text = params.row.domesticExpressFee || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003643'),
          key: 'customsClearanceFee',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let text = params.row.customsClearanceFee || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003951'),
          key: 'remoteAreasShippingCost',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let text = params.row.remoteAreasShippingCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003952'),
          key: 'returnedItemShippingCost',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            let text = params.row.returnedItemShippingCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003953'),
          key: 'quadraticShippingCost',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let text = params.row.quadraticShippingCost || 0;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003954'),
          key: 'cancelShippingCost',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let text = params.row.cancelShippingCost || 0;
            return h('span', text);
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599')}`,
          key: 'totalPrice',
          minWidth: 130,
          align: 'center',
          render(h, params) {
            let text = params.row.totalPrice || 0;
            return h('span', text);
          }
        },
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003611')}`,
          key: 'totalPriceCurrency',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003641'), // cancelledTime 取消时间   发货时间  shipedTime    status：7 发货   8取消
          key: 'finishTime',
          minWidth: 170,
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let shipedTime = v.$uDate.dealTime(params.row.shipedTime, 'fulltime');
            let cancelledTime = v.$uDate.dealTime(params.row.cancelledTime, 'fulltime');
            let time = status === 7 ? shipedTime : status === 8 ? cancelledTime : '-';
            return h('span', time);
          }
        }
      ],
      consumptionRecordsData: [],
      ymsBillId: null,
      userInfoList:{},
      enumData: [],
    };
  },
  created() {
    this.ymsBillId = this.$route.query.ymsBillId;
    this.initCustomerBillDetails();
  },
  methods: {
    // 初始化数据
    initCustomerBillDetails() {
      (async () => {
        let enumKeyList = ['YmsPackageInfoStatusCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
        });
        await this.getCustomerBillDetailsData();
        await this.getRechargeRecordData();
        await this.getConsumptionRecordsData();
      })();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/customerBill');
    },
    // 获取物流账单详情数据
    getCustomerBillDetailsData() {
      let v = this;
      v.detailsData = {};
      v.axios.get(api.get_ymsBill_distributorBill + v.ymsBillId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            data['accumulatedRecharge'] = data.platformRechargePrice + data.handRechargePrice;
            let costKeyList = ['accumulatedRecharge', 'platformRechargePrice', 'handRechargePrice', 'consumptionAmount'];
            costKeyList.map((key) => {
              if (!isValueEmpty(data[key])) {
                data[key] = v.formatCurrency(data[key]) + ' ' + data.currency;
              }
            });
            data.createdTime = v.$uDate.dealTime(data.createdTime, 'fulltime') || '-';
            if (data.billMonth) {
              let time = data.billMonth.split('-');
              data.billTime = `${time[0]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000492')}${time[1]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493')}`;
            }
            v.detailsData = data;
          }
        }
      });
    },
    // 获取充值记录明细列表数据
    getRechargeRecordData() {
      let v = this;
      v.optionBtnWidth = [];
      v.rechargeRecordData = [];
      v.rechargeRecordTotal = 0;
      v.tableLoading = true;
      let query = Object.assign({}, v.rechargeRecordPageParams);
      query.ymsBillId = v.ymsBillId;
      v.axios.post(api.post_ymsBillPackageDetail_billDetailRechargeRecord, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.rechargeRecordData = data.list || [];
            v.rechargeRecordTotal = data.total;
          }
        }
      });
    },
    // 获取消费记录明细列表
    getConsumptionRecordsData() {
      let v = this;
      v.optionBtnWidth = [];
      v.consumptionRecordsData = [];
      v.consumptionRecordsTotal = 0;
      v.tableLoading = true;
      let query = Object.assign({}, v.consumptionRecordsPageParams);
      query.ymsBillId = v.ymsBillId;
      v.axios.post(api.post_ymsBillPackageDetail_billDetailPackageInfo, query).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.consumptionRecordsData = data.list || [];
            v.consumptionRecordsTotal = data.total;
          }
        }
      });
    },

    // 切换分页
    changeTypePage(page, type) {
      let v = this;
      v[type].pageNum = page;
      if (type === 'consumptionRecordsPageParams') {
        v.getConsumptionRecordsData();
      } else {
        v.getRechargeRecordData();
      }
    },
    // 切换每页条数时的回调，返回切换后的每页条数
    changeTypePageSize(pageSize, type) {
      let v = this;
      v[type].pageSize = pageSize;
      if (type === 'consumptionRecordsPageParams') {
        v.getConsumptionRecordsData();
      } else {
        v.getRechargeRecordData();
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>
